//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'cardbox',
	props: {
        showTitle: {
            default: false,
            type: Boolean,
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/ui/cardbox.vue